import { sanitizeFilename } from "../sanitizeFilename";

export function quickAssessmentToPptDocument(result) {
  const slides = [
    {
      kind: "title",
      title: result.title,
      subtitle: result.curriculumLabel,
    },
    {
      kind: "bullets",
      title: "Instructions",
      bullets: [result.instructions],
    },
    {
      kind: "bullets",
      title: "Questions",
      bullets: (result.questions ?? []).map((question) => {
        if (question.questionType === "mcq" && question.options?.length) {
          return `${question.number}. ${question.prompt}\n${question.options.join("\n")}`;
        }
        return `${question.number}. ${question.prompt}`;
      }),
    },
  ];

  return {
    filename: sanitizeFilename(result.title, "quick-assessment"),
    title: result.title,
    subject: result.curriculumLabel,
    author: "Tema Quick Assessment",
    slides,
  };
}
